const centFormatter = new Intl.NumberFormat("en-US", {
  useGrouping: false, minimumFractionDigits: 2, maximumFractionDigits: 2,
});

/** Presentation only. Never feeds rounded values back into the offer calculation. */
export function offerPartsOverview(totals: {
  parts: Array<{ title: string; included: boolean; subtotal: number }>;
  subtotal: number; tax: number; total: number;
}) {
  // Use the same Intl rounding as the monetary display, even at large half-cent
  // values where adding Number.EPSILON would not reliably correct binary errors.
  const cents = (value: number) => {
    const rounded = Math.round(Number(centFormatter.format(value)) * 100);
    return Object.is(rounded, -0) ? 0 : rounded;
  };
  const rows = totals.parts.map((part) => {
    const net = cents(part.subtotal);
    const tax = cents(part.subtotal * 0.20);
    // Each displayed row adds up in cents; differences from the original,
    // full-precision totals are reported below, never written back.
    return { title: part.title, included: part.included, net, tax, gross: net + tax };
  });
  const roundedSum = rows.filter((row) => row.included).reduce((sum, row) => ({
    net: sum.net + row.net, tax: sum.tax + row.tax, gross: sum.gross + row.gross,
  }), { net: 0, tax: 0, gross: 0 });
  const authoritative = { net: cents(totals.subtotal), tax: cents(totals.tax), gross: cents(totals.total) };
  const difference = {
    net: roundedSum.net - authoritative.net,
    tax: roundedSum.tax - authoritative.tax,
    gross: roundedSum.gross - authoritative.gross,
  };
  const roundingNote = Object.values(difference).some((value) => value !== 0)
    ? `Rundungsabweichung der Teilbeträge gegenüber dem Summenkasten (Netto / MwSt. / Brutto): ${difference.net} / ${difference.tax} / ${difference.gross} Cent. Maßgeblich ist der Summenkasten; die Summenzeile ist daran angepasst.`
    : null;
  return { rows, sum: roundingNote ? authoritative : roundedSum, roundedSum, roundingNote };
}
